





















import { CartAdd, OneClick } from "@/components/icons";

export default {
  name: "CartTable",
  components: {
    "cart-add": CartAdd,
    "one-click": OneClick,
  },
  props: {
    action: { type: Function, default: () => null },
    type: { type: String, default: "" },
    icon: { type: String, default: "" },
    color: { type: String, default: "transparent" },
    title: { type: String, default: "" },
    iconTitle: { type: String, default: "" },
    border: { type: Boolean, default: false },
  },
};
